import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
  variant?: "grid" | "compact";
};

export default function MovieCard({ movie, variant = "grid" }: MovieCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/detail/${movie.id}`}
        className="group flex gap-3 rounded-lg bg-background-900/70 border border-background-800 p-2 hover:border-primary-700 transition-colors"
      >
        <div className="relative w-20 h-28 shrink-0 overflow-hidden rounded-md bg-background-800">
          <img
            src={movie.poster}
            alt={`${movie.title} 海报`}
            title={`${movie.title} 剧情介绍`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="min-w-0 flex flex-col py-1">
          <h3 className="font-heading text-sm text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-1">
            {movie.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">
            {movie.year} · {movie.region}
          </p>
          <p className="text-xs text-foreground-400 mt-1 line-clamp-2 leading-relaxed">
            {movie.synopsis}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-900/70 border border-background-800 hover:border-primary-700 transition-colors"
    >
      <div className="relative aspect-[2/3] overflow-hidden bg-background-800">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 剧情介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-950/80 text-accent-400 text-xs font-label font-medium">
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3 md:p-4 flex flex-col flex-1">
        <h3 className="font-heading text-sm md:text-base text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5">
          {movie.year} · {movie.region} · {movie.duration}分钟
        </p>
        <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed flex-1">
          {movie.synopsis}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 2).map((g) => (
            <span key={g} className="px-2 py-0.5 rounded-full bg-secondary-900/60 text-secondary-200 text-[11px]">
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}